<template>
  <common-dialog ref="dialog" :title="title" width="1100px" :in-dialog="inDialog">
    <list ref="list" common :show-query="true" :show-checkbox="multiple" :multiple="multiple" :is-show="true"  :modelType="modelType" >
          <template #column>
            <slot name="column" />
            <template v-if="selectable&&!multiple">
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="{row}">
                  <el-button :disabled="row.DistrictId==NoId" @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";


export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "产品组合方案",
    },
    modelType: {
      type: String,
      default: "businesssalesquotation",
    },
  },
  data() {
    return {
      params: {},
      NoId: 0,
    };
  },
  methods: {
    getData(params = {}) {
      // console.log('我执行到这');
      // this.NoId = params.NoId;
      this.params = { ...params };
      this.$refs.list.showTable(this.params);
    //   this.$refs.tree.getData();
    },
    treeSelect(data) {
      this.$refs.list.showTable({ ...this.params, IdChain: data.IdChain });
    },
    titleClick() {
      this.$refs.list.showTable({ ...this.params, IdChain: null });
    },
  },
};
</script>